import React from "react";
import { Fragment } from "react";

export default function ThemeSettingHeader() {
  return (
    <Fragment>
      <div className="col-sm-5 ">
        <h2>Theme Setting</h2>
      </div>
    </Fragment>
  );
}
